import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

const NavListItem = ({
  onClick,
  cssClass,
  url,
  pathname,
  text,
  notificationsCount,
  displayNotificationsCountIfZero,
  notificationCssClass,
  needsRefresh
}) => {
  const theme = useTheme()
  const [shouldShowLabel, setShouldShowLabel] = useState(false)

  const onKeyPress = e => {
    if (e.which === 13 || e.keyCode === 13) {
      onClick(e)
    }
  }

  const showLabel = () => {
    setShouldShowLabel(true)
  }

  const hideLabel = () => {
    setShouldShowLabel(false)
  }

  const getNotificationsCss = () => {
    let css = 'notifications'

    if (notificationCssClass) {
      css += ' ' + notificationCssClass
    }

    if (needsRefresh) {
      css += ' needs-refresh'
    }

    return css
  }

  const getMenuClassList = (itemClass, location) => {
    const selectedMenu = pathname ? pathname : undefined
    const active =
      selectedMenu && location.length > 0
        ? selectedMenu.indexOf(location[0]) > -1
          ? ' active'
          : ''
        : ''

    return `nav-item item theme-${theme?.style} ` + itemClass + active
  }

  return (
    <li
      className={getMenuClassList(cssClass, [url])}
      data-url={url}
      onClick={(e)=> {
        onClick(e)
        setTimeout(() => hideLabel(), 500)
      }}
      onKeyPress={onKeyPress}
    >
      <div
        tabIndex="0"
        aria-label={text}
        className="icon"
        onMouseOver={showLabel}
        onMouseOut={hideLabel}
      />
      {(notificationsCount > 0 || displayNotificationsCountIfZero) && (
        <div className={getNotificationsCss()}>
          {notificationsCount < 1000 ? notificationsCount : '999+'}
        </div>
      )}
      <label className={shouldShowLabel ? 'active' : ''}>{text}</label>
    </li>
  )
}

NavListItem.propTypes = {
  onClick: PropTypes.func,
  pathname: PropTypes.string,
  url: PropTypes.string,
  text: PropTypes.string,
  cssClass: PropTypes.string,
  notificationCssClass: PropTypes.string,
  notificationsCount: PropTypes.number,
  needsRefresh: PropTypes.bool,
  displayNotificationsCountIfZero: PropTypes.bool
}

export default NavListItem
